import { render, staticRenderFns } from "./LayerIcon.vue?vue&type=template&id=53c67be6&scoped=true&"
import script from "./LayerIcon.vue?vue&type=script&lang=ts&"
export * from "./LayerIcon.vue?vue&type=script&lang=ts&"
import style0 from "./LayerIcon.vue?vue&type=style&index=0&id=53c67be6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c67be6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
